import { paxFullName } from "@/lib/newTripConstants";

// Pure helper extracted from NewTripModal.
// For each international leg, returns a flat list of human-readable strings
// describing every passport that is (or will be) expired by the leg's
// departure date. Crew passports come from the `crewPassportMap` keyed by
// user_id with ISO YYYY-MM-DD strings.
//
// Comparison is done as plain ISO YYYY-MM-DD lex strings — no `new Date()`
// inside the hot loop. That's both faster on big legs/pax lists and avoids
// the prior bug where `new Date("2026-12-30") < new Date("2026-12-31")`
// returned UTC-skewed results depending on the browser timezone.
export function derivePassportConflicts(legs, crewPassportMap) {
  const today = new Date();
  // Local ISO YYYY-MM-DD (avoids the toISOString() UTC-shift trap on
  // negative-offset zones where `toISOString().slice(0,10)` returns
  // "yesterday" locally).
  const pad = (n) => String(n).padStart(2, "0");
  const todayIso = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;

  const isExpired = (expiration, refIso) => {
    if (!expiration) return false;
    const exp = String(expiration).slice(0, 10);
    return exp < refIso;
  };

  return legs.flatMap((leg, li) => {
    if (!leg.is_international) return [];
    const refIso = leg.departure_date ? String(leg.departure_date).slice(0, 10) : todayIso;
    const issues = [];

    (leg.passengers || []).forEach((pax) => {
      const fullName = paxFullName(pax);
      if (!fullName) return;
      if (isExpired(pax.passport_expiration, refIso)) {
        const label = leg.departure_date
          ? `estará vencido en la fecha de salida (${leg.departure_date})`
          : "está vencido";
        issues.push(
          `Tramo ${li + 1} – Pasajero "${fullName}": pasaporte ${label} — vence: ${pax.passport_expiration}`
        );
      }
    });

    (leg.crew || []).forEach((c) => {
      const exp = crewPassportMap?.[c.user_id];
      if (isExpired(exp, refIso)) {
        const label = leg.departure_date
          ? `estará vencido en la fecha de salida (${leg.departure_date})`
          : "está vencido";
        issues.push(
          `Tramo ${li + 1} – Tripulación "${c.name}": pasaporte ${label} — vence: ${exp}`
        );
      }
    });

    return issues;
  });
}
